import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';

import { PlayVideoContent } from './PlayVideoContent';

export const NubankerContentLink = styled(Link)`
  position: relative;
  cursor: pointer;
  display: block;
  outline: none;

  &:hover ${PlayVideoContent} {
    opacity: 1;
  }
`;

NubankerContentLink.displayName = 'NubankerContentLink';
